import * as React from 'react'
import {Alert, Checkbox, Col, Form, Input, Modal, notification, Row, Spin} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {withTranslation, WithTranslation} from 'react-i18next';
import {NewCompanyItem, NewCompanyStore} from 'src/stores/companies-store';
import {connect} from 'redux-scaffolding-ts'
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {GetFieldDecoratorOptions, ValidationRule} from 'antd/lib/form/Form';
import {formatMessage} from '../../../core/services/http.service';
import TenantSelector from 'src/components/tenant-selector';
import {UserProfileProps} from "../../../components/user-profile";

let FormItem = Form.Item;

interface NewCompanyViewProps extends UserProfileProps{
    onClose: (id: string | undefined, item?: NewCompanyItem) => void;
}

interface NewCompanyViewState {
}

interface ClassFormBodyProps extends WithTranslation, UserProfileProps {
    item: NewCompanyItem | undefined,
    onSave?: () => Promise<any>;
    setFieldsValue: any;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    getFieldsValue?: () => any;
}

export class CompanyFormBody extends React.Component<ClassFormBodyProps, NewCompanyViewState> {

    constructor(props: ClassFormBodyProps) {
        super(props);
        let item = this.props.item || {} as NewCompanyItem;
        this.state = {
        }
    }

    render() {
        const { t } = this.props;
        let weekValidator: ValidationRule = { type: 'number', required: false, whitespace: false, min: 0, max: 168, transform: value => 1 * value, message: t("Value must be a number between 0 and 168") };
        var item = this.props.item || {} as NewCompanyItem;

        return <Form id="modaForm" onKeyUp={(e) => { if (e.keyCode===13 && this.props.onSave) { this.props.onSave(); } }} onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}>
            <Row gutter={24}>
                <Col span={12}>
                    <FormItem label={t("Company Name")}>
                        {this.props.getFieldDecorator(nameof<NewCompanyItem>('title'), {
                            initialValue: item.title,
                            rules: [{ required: true, message: t('Name required') },
                            { whitespace: true, message: t('Name required') }],
                        })(
                            <Input placeholder={t("Name")} type="text" maxLength={255} />
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem label={t("Reference")}>
                        {this.props.getFieldDecorator(nameof<NewCompanyItem>('reference'), {
                            initialValue: item.reference,
                            rules: [{ required: false, message: t('Reference required') }],
                        })(
                            <Input placeholder={t('Optional reference')} type="text" />
                        )}
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24} data-tut="reactour__navegateCompany1">
                <Col span={12}>
                    <FormItem label={t("Tenant")}>
                        {this.props.getFieldDecorator(nameof<NewCompanyItem>('tenantId'), {
                            rules: [
                                { required: true, message: t('Tenant required') }
                            ],
                        })(
                            <TenantSelector loadTenantId={true} />
                        )}
                    </FormItem>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24}>
                    <FormItem>
                        {this.props.getFieldDecorator(nameof<NewCompanyItem>('generateTimesheetTasks'), {
                            rules: [],
                            initialValue: true,
                            valuePropName: 'checked'
                        })(
                            <Checkbox><span>{t("Generate timesheets tasks automatically")}</span></Checkbox>
                        )}
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem>
                        {this.props.getFieldDecorator(nameof<NewCompanyItem>('cloneTimesheetManual'), {
                            rules: [],
                            initialValue: false,
                            valuePropName: 'checked'
                        })(
                            <Checkbox><span>{t("Clone timesheets manually")}</span></Checkbox>
                        )}
                    </FormItem>
                </Col> 
                {/*<Col span={12}>*/}
                {/*    <FormItem>*/}
                {/*        {this.props.getFieldDecorator(nameof<NewCompanyItem>('hoursManagerUsers'), {*/}
                {/*            rules: [],*/}
                {/*            initialValue: false,*/}
                {/*            valuePropName: 'checked'*/}
                {/*        })(*/}
                {/*            <Checkbox><span>{t("Hours manager for users")}</span></Checkbox>*/}
                {/*        )}*/}
                {/*    </FormItem>*/}
                {/*</Col>*/}                
            </Row>
            {/*<Row gutter={24}>
                <Col span={24}>
                    <WeekHoursEditor i18n={this.props.i18n} t={this.props.t} tReady={this.props.tReady} value={{ minhours: this.state.minhours, maxhours: this.state.maxhours }} onChange={this.hoursChange} />
                </Col>
            </Row>*/}
        </Form>
    }
}

@connect(["newCompany", NewCompanyStore])
class NewCompanyView extends React.Component<NewCompanyViewProps & WithTranslation & FormComponentProps, NewCompanyViewState> {
    private get newCompanyStore() {
        return (this.props as any).newCompany as NewCompanyStore;
    }

    constructor(props: NewCompanyViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
        }
        this.newCompanyStore.createNew({ } as any);
    }

    componentWillReceiveProps(nextProps: NewCompanyViewProps) {
        if (this.newCompanyStore.state.result && this.newCompanyStore.state.result.isSuccess)
            this.props.onClose((this.newCompanyStore.state.result as any).aggregateRootId, this.newCompanyStore.state.item)
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private onCreateNewItem() {
        var self = this;
        const { t } = this.props;
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue();
                values['tenantName'] = values['tenantId']['label'][1]
                values['tenantId'] = values['tenantId']['key']
                if (!event) {
                    self.newCompanyStore.change(values);
                    self.newCompanyStore.submit().then(result => {
                        if (result.isSuccess) {
                            resolve();
                            this.countDownNotification(notification.success, t("Notification"), t("The company was created successfully"), "success");
                        } else {
                            this.countDownNotification(notification.error, t("Error"), t("There was an error. The company was not created."), "failure");
                            reject();
                        }
                    });
                }
            });
        })
    }

    @autobind
    private onCancelNewItem() {
        this.newCompanyStore.clear();
        this.props.onClose(undefined);
    }

    public render() {
        const { t } = this.props;
        const { getFieldDecorator, setFieldsValue } = this.props.form;
        return (
            <Modal
                maskClosable={false}
                visible
                onCancel={this.onCancelNewItem}
                onOk={this.onCreateNewItem}
                closable={false}
                width='800px'
                okText={t("OK")}
                cancelText={t("Cancel")}
                title={t("New company")}>
                {this.newCompanyStore.state.result && !this.newCompanyStore.state.result.isSuccess &&
                    <Alert type='error'
                        message={t("Error")}
                        description={formatMessage(this.newCompanyStore.state.result)}
                    />
                }
                <Spin spinning={this.newCompanyStore.state.isBusy}>
                    <CompanyFormBody
                        userProfile={this.props.userProfile}
                        setFieldsValue={this.props.form.setFieldsValue}
                        //onHoursChange={this.onHoursChange}
                        i18n={this.props.i18n}
                        t={this.props.t}
                        tReady={this.props.tReady}
                        item={this.newCompanyStore.state.item}
                        getFieldDecorator={getFieldDecorator}
                        onSave={this.onCreateNewItem} />
                </Spin>
            </Modal>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(NewCompanyView as any) as any) as any as React.ComponentClass<NewCompanyViewProps>;